import React, { useEffect } from 'react'
import ReactDOM from 'react-dom'

const MonitoringModal = ({url, title = 'Starta bevakning', onClose}) => {

    useEffect( () => {

        function handleEsc(e){
            if (e.key === 'Escape') {
                e.preventDefault();
                onClose();
            }
        }

        document.addEventListener('keydown', handleEsc)

        return function(){
            document.removeEventListener('keydown', handleEsc)
        }
    },[onClose])

    // Close when clicking the backdrop, but not the modal itself
    const handleBackdrop = (e) => {
        if( e.target === e.currentTarget ) {
            onClose()
        }
    }

    // Rendered on body, the sticky cars-header creates a stacking context
    // that would trap the modal behind the cars and sliders
    return ReactDOM.createPortal(
        <div className="modal_backdrop" onClick={handleBackdrop}>
            <div className="modal modal_iframe">
                <div className="modal_header">
                    <h3>{ title }</h3>
                    <button onClick={ onClose } title="Stäng"></button>
                </div>
                <div className="modal_content">
                    <iframe src={url} title={title} frameBorder="0"></iframe>
                </div>
            </div>
        </div>,
        document.body
    )
}

export default MonitoringModal
